module.exports = "/images/vendor/flag-icon-css/flags/4x3/uz.svg?eb1e00b870d7f0784288d76eb3bfc1d5";